module.exports = __webpack_public_path__ + "static/media/all_dunes.11dbd192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/all_dunes.jpg
// module id = 357
// module chunks = 0